(function () {
  'use strict';

  if (window.__arameleStylePreviewLoaded) return;
  window.__arameleStylePreviewLoaded = true;

  var sectionSelector = '.aramele-product-v2[data-section-type="product"]';
  var styleSelector = '[data-aramele-style-selector]';
  var affirmationHandle = 'tree-of-life-affirmation-necklace';

  function imageSource(variant) {
    if (!variant) return '';

    if (
      variant.featured_media &&
      variant.featured_media.preview_image &&
      variant.featured_media.preview_image.src
    ) {
      return variant.featured_media.preview_image.src;
    }

    if (variant.featured_image && variant.featured_image.src) {
      return variant.featured_image.src;
    }

    return '';
  }

  function sizedImageUrl(src, size) {
    if (!src) return '';

    if (
      window.theme &&
      window.theme.Images &&
      typeof window.theme.Images.getSizedImageUrl === 'function'
    ) {
      try {
        return window.theme.Images.getSizedImageUrl(src, size + 'x');
      } catch (error) {
        // Fall back to Shopify's width query below.
      }
    }

    return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + size;
  }

  function ArameleStylePreview(container) {
    if (container.dataset.arameleStylePreviewReady === 'true') return;

    var variantsElement = container.querySelector('[data-variant-json]');
    var selectors = container.querySelectorAll(styleSelector);

    if (!variantsElement || !selectors.length) return;

    try {
      this.variants = JSON.parse(variantsElement.value || variantsElement.textContent);
    } catch (error) {
      return;
    }

    if (!Array.isArray(this.variants) || !this.variants.length) return;

    this.container = container;
    this.selectors = selectors;
    this.onVariantChange = this.onVariantChange.bind(this);
    this.container.addEventListener('variantChange', this.onVariantChange);
    this.container.dataset.arameleStylePreviewReady = 'true';

    this.refresh();
  }

  ArameleStylePreview.prototype.selectedOptions = function () {
    var selected = [];
    var optionCount = this.variants[0].options.length;

    for (var index = 0; index < optionCount; index += 1) {
      var dataIndex = 'option' + (index + 1);
      var input = this.container.querySelector(
        '[data-variant-input][data-index="' + dataIndex + '"]:checked'
      );

      if (!input) {
        input = this.container.querySelector(
          'select[data-variant-input][data-index="' + dataIndex + '"]'
        );
      }

      selected[index] = input ? input.value : '';
    }

    return selected;
  };

  ArameleStylePreview.prototype.variantForStyle = function (selector, value) {
    var selected = this.selectedOptions();
    var styleIndex = parseInt(selector.dataset.arameleStyleIndex, 10);

    if (isNaN(styleIndex)) return null;
    selected[styleIndex] = value;

    var exactAvailable = this.variants.find(function (variant) {
      return variant.available && variant.options.every(function (option, index) {
        return option === selected[index];
      });
    });

    if (exactAvailable) return exactAvailable;

    var exact = this.variants.find(function (variant) {
      return variant.options.every(function (option, index) {
        return option === selected[index];
      });
    });

    if (exact) return exact;

    return this.variants.find(function (variant) {
      return variant.options[styleIndex] === value && imageSource(variant);
    }) || null;
  };

  ArameleStylePreview.prototype.updateCards = function (selector) {
    var self = this;

    selector.querySelectorAll('[data-aramele-style-value]').forEach(function (card) {
      var value = card.dataset.arameleStyleValue;
      var variant = self.variantForStyle(selector, value);
      var src = sizedImageUrl(imageSource(variant), 240);
      var image = card.querySelector('[data-aramele-style-image]');

      if (image && src) {
        image.src = src;
        image.alt = value + ' preview';
      }
    });
  };

  ArameleStylePreview.prototype.cardImageForStyle = function (selector, value) {
    var cards = selector.querySelectorAll('[data-aramele-style-value]');

    for (var index = 0; index < cards.length; index += 1) {
      if (cards[index].dataset.arameleStyleValue === value) {
        return cards[index].querySelector('[data-aramele-style-image]');
      }
    }

    return null;
  };

  ArameleStylePreview.prototype.updateCurrent = function (selector, variant) {
    var styleIndex = parseInt(selector.dataset.arameleStyleIndex, 10);
    var selectedInput = selector.querySelector('[data-variant-input]:checked');
    var selectedValue = variant && !isNaN(styleIndex)
      ? variant.options[styleIndex]
      : (selectedInput ? selectedInput.value : '');
    var name = selector.querySelector('[data-aramele-style-current-name]');
    var image = selector.querySelector('[data-aramele-style-current-image]');
    var selectedCardImage = this.cardImageForStyle(selector, selectedValue);
    var selectedVariant = variant || this.variantForStyle(selector, selectedValue);
    var src = selectedCardImage
      ? (selectedCardImage.getAttribute('src') || selectedCardImage.currentSrc)
      : sizedImageUrl(imageSource(selectedVariant), 180);

    if (name && selectedValue) {
      name.textContent = selectedValue;
    }

    if (image && src) {
      image.src = src;
      image.alt = selectedValue + ' preview';
    }
  };

  ArameleStylePreview.prototype.refresh = function (variant) {
    var self = this;

    this.selectors.forEach(function (selector) {
      self.updateCards(selector);
      self.updateCurrent(selector, variant);
    });
  };

  ArameleStylePreview.prototype.onVariantChange = function (event) {
    this.refresh(event.detail ? event.detail.variant : null);
  };

  function isAffirmationProduct(container) {
    return container && container.dataset.productHandle === affirmationHandle;
  }

  function unlockAffirmationOptions(container) {
    if (
      !isAffirmationProduct(container) ||
      container.dataset.arameleAffirmationUnlockReady === 'true'
    ) {
      return;
    }

    container.dataset.arameleAffirmationUnlockReady = 'true';

    var dynamicVariants = container.querySelector('[data-dynamic-variants-enabled]');
    if (dynamicVariants) {
      dynamicVariants.removeAttribute('data-dynamic-variants-enabled');
    }

    function unlock() {
      container.querySelectorAll('.variant-input-wrap .disabled').forEach(function (element) {
        element.classList.remove('disabled');
      });

      container.querySelectorAll('.variant-input-wrap input[data-variant-input]').forEach(function (input) {
        input.disabled = false;
        input.removeAttribute('disabled');
        input.removeAttribute('aria-disabled');
      });

      container.querySelectorAll('.variant-input-wrap [aria-disabled="true"]').forEach(function (element) {
        element.removeAttribute('aria-disabled');
      });

      container.querySelectorAll('.variant-input-wrap select[data-variant-input], .variant-input-wrap option').forEach(function (element) {
        element.disabled = false;
        element.removeAttribute('disabled');
        element.removeAttribute('aria-disabled');
      });
    }

    unlock();

    var pending = false;
    var observer = new MutationObserver(function () {
      if (pending) return;
      pending = true;

      window.requestAnimationFrame(function () {
        pending = false;
        unlock();
      });
    });

    observer.observe(container, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'disabled', 'aria-disabled']
    });
  }

  function tailorAffirmationPage(container) {
    if (!isAffirmationProduct(container)) return;

    var personalization = container.querySelector('.aramele-personalization');
    if (personalization) {
      personalization.querySelectorAll('input, textarea, select').forEach(function (field) {
        field.disabled = true;
        field.removeAttribute('required');
        field.removeAttribute('aria-required');
      });
      personalization.remove();
    }

    var story = document.querySelector('.aramele-story-section .aramele-story');
    if (!story || story.dataset.arameleAffirmationStoryReady === 'true') return;

    story.dataset.arameleAffirmationStoryReady = 'true';

    var eyebrow = story.querySelector('.aramele-story__eyebrow');
    var heading = story.querySelector('.aramele-story__heading');
    var copy = story.querySelector('.aramele-story__copy');
    var steps = story.querySelectorAll('.aramele-story__step');

    if (eyebrow) eyebrow.textContent = 'WEAR YOUR INTENTION';
    if (heading) heading.textContent = 'Choose the words you want to carry.';
    if (copy) {
      copy.innerHTML = '<p>Each Tree of Life design brings together a set of affirmations around strength, peace, gratitude, confidence and growth. Choose the message that speaks to you, then select the finish and length that feel right.</p>';
    }

    var storyPoints = [
      {
        title: 'Choose your affirmation',
        text: 'Select the set of words that matches the intention you want to keep close.'
      },
      {
        title: 'Choose your finish and length',
        text: 'Pick gold, rose gold or silver, then select your preferred chain length.'
      },
      {
        title: 'Carry the reminder',
        text: 'Wear it as a small daily cue to return to the words that matter most.'
      }
    ];

    steps.forEach(function (step, index) {
      var point = storyPoints[index];
      if (!point) return;

      var title = step.querySelector('h3');
      var text = step.querySelector('p');
      if (title) title.textContent = point.title;
      if (text) text.textContent = point.text;
    });
  }

  function initialize(root) {
    if (root.matches && root.matches(sectionSelector)) {
      new ArameleStylePreview(root);
      unlockAffirmationOptions(root);
      tailorAffirmationPage(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll(sectionSelector).forEach(function (section) {
        new ArameleStylePreview(section);
        unlockAffirmationOptions(section);
        tailorAffirmationPage(section);
      });
    }
  }

  function start() {
    initialize(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initialize(event.target);
    var productSection = document.querySelector(sectionSelector);
    if (productSection) tailorAffirmationPage(productSection);
  });
})();
